/* eslint-disable camelcase */
import { useState, useEffect } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Box from '@mui/material/Box';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';

import Collapse from '@mui/material/Collapse';
// material
import {
  Card,
  Table,
  Stack,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Page from '../../components/Page';
import Scrollbar from '../../components/Scrollbar';
import { PetListListHead } from '../../sections/@dashboard/petList';
// mock
import { getPetListData } from '../../common/api-service';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'User Name', alignRight: false },
  { id: 'pet_details', label: 'Pet Details', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

export default function PetList() {
  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);
  const [collapsed, setCollapsed] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filteredData, setFilteredData] = useState([]);

  const [open, setOpen] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [offset, setOffset] = useState(false);
  const [data, setData] = useState([]);

  const offer = () => {
    return getPetListData().then(
      (res) => {
        setData(res.data.data);
        setFilteredData(res.data.data);
      },
      (err) => {
        console.log('err data: ', err);
      }
    );
  };

  useEffect(() => {
    offer();
  }, [offset]);

  const handlePetListSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = data.map((n) => n._id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleCollapsed = (event, _id) => {
    const selectedIndex = collapsed.indexOf(_id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(collapsed, _id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(collapsed.slice(1));
    } else if (selectedIndex === collapsed.length - 1) {
      newSelected = newSelected.concat(collapsed.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(collapsed.slice(0, selectedIndex), collapsed.slice(selectedIndex + 1));
    }
    setCollapsed(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data.length) : 0;

  return (
    <Page title="User">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            PetList
          </Typography>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              {filteredData.length === 0 ? (
                <Typography component="div">
                  <Box sx={{ textAlign: 'center', m: 1 }}>No Data available</Box>
                </Typography>
              ) : (
                <Table>
                  <PetListListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={data.length}
                    numSelected={selected.length}
                    onPetListSort={handlePetListSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      const { _id, name, pets } = row;

                      const isItemCollapsed = collapsed.indexOf(_id) !== -1;
                      const isItemSelected = selected.indexOf(_id) !== -1;

                      return (
                        <>
                          <TableRow
                            hover
                            key={_id}
                            tabIndex={-1}
                            role="checkbox"
                            selected={isItemSelected}
                            aria-checked={isItemSelected}
                          >
                            <TableCell component="th" scope="row">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                <Typography variant="subtitle2" noWrap>
                                  {name}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell>
                              Show Details
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={(event) => {
                                  setOpen(!open);
                                  return handleCollapsed(event, _id);
                                }}
                              >
                                {isItemCollapsed ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                              </IconButton>
                            </TableCell>
                            {/* {pets.map((a) => (
                              <TableRow
                                hover
                                key={_id}
                                tabIndex={-1}
                                role="checkbox"
                                selected={isItemSelected}
                                aria-checked={isItemSelected}
                              ></TableRow>
                            ))} */}
                          </TableRow>
                          <TableRow>
                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                              <Collapse in={isItemCollapsed} timeout="auto" unmountOnExit>
                                <Box sx={{ margin: 1 }}>
                                  {pets.length === 0 ? (
                                    <Typography variant="h6" gutterBottom component="div">
                                      No pets available
                                    </Typography>
                                  ) : (
                                    <>
                                      <Typography variant="h6" gutterBottom component="div">
                                        Pet Details
                                      </Typography>
                                      <Table size="small" aria-label="purchases">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell>Pet Name</TableCell>
                                            <TableCell>Pet Type</TableCell>
                                            <TableCell>Breed</TableCell>
                                            <TableCell>Gender</TableCell>
                                          </TableRow>
                                        </TableHead>

                                        {pets.map((pet) => {
                                          return (
                                            <TableRow>
                                              <TableCell>{pet.name}</TableCell>
                                              <TableCell>{pet.pet_type}</TableCell>
                                              <TableCell>{pet.breed}</TableCell>
                                              <TableCell>{pet.gender}</TableCell>
                                            </TableRow>
                                          );
                                        })}
                                      </Table>
                                    </>
                                  )}
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
